export const UpdateList = [
	{
		date:'2026-05-25',
		comment:'ホームページリニューアル',
	},
	{
		date:'2026-05-28',
		comment:'Galleryページ に イラスト2点 追加。\n更新履歴(これ) を 追加しました。\nその他、仕様の追加/不具合の修正を行いました。',
	},

];